module.exports = __webpack_public_path__ + "static/img/bigBox.9567c20.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freeSign/bigBox.webp
// module id = QY/d
// module chunks = 0